import { FC } from 'react'
import { IconBaseProps } from 'react-icons/lib'
import {
  MdAccessAlarm,
  MdCheckCircle,
  MdMessage,
  MdOutlineBuildCircle,
  MdRemoveCircle,
  MdSchedule,
} from 'react-icons/md'

import { WIZARD_STATUS } from 'src/utils/constant'
import { getWizardColorByStatusFn } from 'src/utils/wizardUtils'

interface WizardStatusIconProps extends IconBaseProps {
  status: string
}

const WizardStatusIcon: FC<WizardStatusIconProps> = ({ status, ...svgProps }) => {
  const color = getWizardColorByStatusFn(status)

  switch (status) {
    case WIZARD_STATUS.success:
      return <MdCheckCircle style={{ color }} {...svgProps} />
    case WIZARD_STATUS.in_progress:
      return <MdSchedule style={{ color }} {...svgProps} />
    case WIZARD_STATUS.pending:
      return <MdAccessAlarm style={{ color }} {...svgProps} />
    case WIZARD_STATUS.key_values_notification:
      return <MdMessage style={{ color }} {...svgProps} />
    case WIZARD_STATUS.error:
      return <MdRemoveCircle style={{ color }} {...svgProps} />
    case WIZARD_STATUS.in_maintenance:
      return <MdOutlineBuildCircle style={{ color }} {...svgProps} />
    case WIZARD_STATUS.zero_revenue:
      return <MdCheckCircle style={{ color }} {...svgProps} />
    default:
      return null
  }
}

export default WizardStatusIcon
